import { render, staticRenderFns } from "./ServizioList.vue?vue&type=template&id=b6eec4fe&"
import script from "./ServizioList.vue?vue&type=script&lang=ts&"
export * from "./ServizioList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports